const horizontalRule = (editor) => {

    editor.BlockManager.add(`horizontalRule`, {
        category: 'Typography',
        label: `Horizontal Rule`,
        attributes: { class: 'fa fa-minus' },
        content: `<hr class='m-2'>`
    });
} 

export default horizontalRule;